import React from "react";
import { tv } from "tailwind-variants";
import { cn } from "../../utils/styles";

const statusChipVariants = tv({
  base: "px-3 py-2 text-[15px] font-normal leading-[18.9px] tracking-[0.5px] rounded-[111px]",
  variants: {
    type: {
      pending: "text-orange-700 bg-yellow-300",
      approved: "text-green-700 bg-green-100",
      missing: "text-gray-550 bg-gray-100",
      denied: "text-red-500 bg-red-100",
    },
  },
});

interface StatusChipProps {
  label: string;
  type: "pending" | "approved" | "missing" | "denied";
  className?: string;
}

export const StatusChip: React.FC<StatusChipProps> = ({ label, type, className }) => {
  return <p className={cn(statusChipVariants({ type }), className)}>{label}</p>;
};
